<template>
  <section :id="sectionId" class="section-block value-section">
    <div class="section-container">
      <span v-reveal class="section-label">Core Values</span>
      <h2 v-reveal class="section-title">{{ sectionTitle }}</h2>
      <p v-reveal class="section-subtitle reveal--delay-1">
        以技术驱动跨境业务增长，助力企业数字化升级
      </p>
      <a-row :gutter="[24, 24]">
        <a-col
          v-for="(item, index) in coreValues"
          :key="item.id || item.title"
          :xs="24"
          :sm="12"
          :lg="6"
        >
          <div v-reveal :class="'reveal--delay-' + (index % 4 + 1)">
            <div class="value-card">
              <div v-if="iconSrc(item)" class="value-card__bg">
                <img
                  class="value-card__bg-img"
                  :src="iconSrc(item)"
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  decoding="async"
                />
                <div class="value-card__overlay"></div>
              </div>
              <div class="value-card__content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script>
import { resolveCoreValueIcon } from "../utils/coreValueIcons";

export default {
  props: {
    sectionId: {
      type: String,
      default: "values"
    },
    sectionTitle: {
      type: String,
      default: "核心价值"
    },
    coreValues: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    iconSrc(item) {
      return resolveCoreValueIcon(item && item.icon);
    }
  }
};
</script>

<style scoped>
.value-section {
  background: var(--bg-soft);
}

.value-card {
  position: relative;
  height: 100%;
  min-height: 200px;
  padding: 22px 20px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--bg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: transform 0.4s, box-shadow 0.4s, border-color 0.4s;
}

.value-card:hover {
  transform: translateY(-6px);
  border-color: rgba(22, 119, 255, 0.25);
  box-shadow: 0 20px 48px rgba(22, 119, 255, 0.12);
}

.value-card__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.value-card__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 40%;
  transform: scale(1.02);
}

.value-card__overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.78);
}

.value-card__content {
  position: relative;
  z-index: 1;
}

.value-card__content h3 {
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--primary-dark);
  letter-spacing: -0.01em;
}

.value-card__content p {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.75;
  font-weight: 500;
  color: #334155;
}

@media (prefers-reduced-motion: reduce) {
  .value-card:hover {
    transform: none;
  }
}
</style>
